import { render, staticRenderFns } from "./formula.vue?vue&type=template&id=5d5eb6b8&scoped=true"
import script from "./formula.vue?vue&type=script&lang=js"
export * from "./formula.vue?vue&type=script&lang=js"
import style0 from "./formula.vue?vue&type=style&index=0&id=5d5eb6b8&prod&lang=scss&scoped=true"
import style1 from "./formula.vue?vue&type=style&index=1&id=5d5eb6b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5eb6b8",
  null
  
)

export default component.exports